module.exports = __webpack_public_path__ + "img/login-girl.beaf5c0b.png";